import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const EditorApplyStylesFTs = ({ styles = '' }) => {
    return _jsx("style", { children: styles });
};
export default React.memo(EditorApplyStylesFTs);
